import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "swiper/css";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import ServiceInclude from "../../component/ServiceInclude";
import { Helmet } from "react-helmet";

const Texas = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    return (
        <>

            <Helmet prioritizeSeoTags={true}>
                <meta http-equiv="content-type" content="text/html; charset=utf-8" />
                <meta name="format-detection" content="telephone=no" />
                <title>Leading salesforce Consultant and Partner in Texas</title>
                <meta name="viewport" content="width=device-width, initial-scale=1" />

                <meta name="description"
                    content="Elevate your business with Codezix – specialists in Salesforce consulting and implementation in texas. Customized CRM solutions to fuel your success."
                />
                <meta
                    name="keywords"
                    content="Salesforce consulting texas Salesforce implementation texas Codezix Salesforce services CRM solutions texas Salesforce experts texas Salesforce partner texas Custom Salesforce solutions"
                />
            </Helmet>

            <div className="service-banner top bottom">
                <div className="container">
                    <div className='explore-heading'>
                        <h2>Salesforce Consultant In Texas</h2>
                    </div>
                    <div className="service-img mt-4">
                        <img src={require('../../assets/images/country/texas.webp')} alt="Salesforce consulting texas" />
                    </div>
                </div>
            </div>

            <div className="container">
                <div className="row">
                    <div className="col-lg-3">
                        <ServiceInclude />
                    </div>

                    <div className="col-lg-9">
                        <div className="salesforce-service">
                            <div className="explore-heading text-left">
                                <h2>Top Salesforce Consultant in Texas and Trusted Partner for Your Business</h2>
                            </div>
                            <p className="prose-lg">In today’s competitive business world, adopting a robust CRM like Salesforce can significantly boost your company’s efficiency and customer engagement. But to truly unlock its potential, you need more than just an implementation—you need a dedicated partner who understands your business needs. That’s where we come in.</p>
                            <p className="prose-lg">As a Salesforce consultant in Texas, Codezix offers expert consulting services tailored to help your business thrive. Our team is committed to delivering innovative Salesforce solutions that streamline processes, improve collaboration, and enhance customer relationships. From initial setup to ongoing support, we provide comprehensive services that ensure your Salesforce platform is perfectly aligned with your business objectives.</p>
                            <p className="prose-lg">Whether you're looking to implement Salesforce for the first time or optimize an existing system, we bring deep industry expertise to every project. Our team specializes in customizing Salesforce to meet the unique needs of businesses in Texas and beyond. We’ve helped companies across various industries—from healthcare and retail to finance and technology—create scalable, efficient CRM solutions that drive measurable growth.</p>
                            <p className="prose-lg">Choosing the right Salesforce consultant in Texas is critical to maximizing the value of your Salesforce investment. At Codezix, we prioritize understanding your specific challenges and goals, working with you to create a personalized strategy that empowers your team and improves performance.</p>
                            <p className="prose-lg">We don't just provide a service—we become a trusted partner in your business’s journey to success. Reach out today to discover how Codezix can help you leverage Salesforce to transform your business and achieve long-term success.</p>
                        </div>
                        <div className='cloud-demo' >
                            <div className="explore-heading text-left">
                                <h2>Expert Salesforce Consulting in Texas – Tailored Solutions for Your Business</h2>
                                <p className="prose-lg">In today’s fast-paced digital landscape, having the right tools to manage customer relationships is essential for business success. Salesforce is one of the most powerful CRM platforms available, but to fully harness its capabilities, you need the expertise of a trusted consultant. That’s where we come in.</p>
                                <p className="prose-lg">As leaders in Salesforce consulting in Texas, Codezix offers tailored solutions that are specifically designed to meet your business’s unique needs. We understand that every company is different, which is why we take a personalized approach to every project. Our experienced consultants work closely with your team to understand your goals, processes, and challenges, ensuring that your Salesforce implementation drives measurable results.</p>
                                <p className="prose-lg">Whether you’re new to Salesforce or looking to optimize an existing setup, our Salesforce consulting in Texas services cover everything from initial implementation and customization to integration and ongoing support. Our team is committed to delivering solutions that streamline your operations, improve customer engagement, and boost your overall efficiency.</p>
                                <p className="prose-lg">At Codezix, we specialize in helping businesses across a range of industries—including retail, healthcare, finance, and technology—unlock the full potential of Salesforce. By leveraging our expertise and industry-specific knowledge, you can be confident that your CRM strategy is aligned with your long-term goals.</p>
                                <p className="prose-lg">If you're looking for a trusted Salesforce consulting in Texas, Codezix is here to help. Our team of certified Salesforce experts is dedicated to empowering your business with solutions that drive growth and success. Contact us today to learn more about how we can tailor Salesforce to meet your needs and transform your business.</p>
                            </div>
                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/consulting.webp')} alt='Salesforce implementation texas' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Salesforce Consulting</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Our certified consultants assess your business needs, streamline processes, and provide strategic guidance tailored to your goals. We help resolve common CRM challenges, including low sales productivity and misalignment between departments, ensuring smoother operations and improved overall efficiency.                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/implementation.webp')} alt='Codezix Salesforce services' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Salesforce Implementation</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Elevate your business with our expert implementation services. Our certified professionals specialize in setting up, customizing, and configuring cloud-based solutions and add-ons, helping you drive innovation, streamline operations, and accelerate growth with technology tailored to your unique business needs
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/customization.webp')} alt='CRM solutions texas' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Salesforce Customization</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Our certified consultants evaluate your business processes to deliver strategic guidance tailored to your goals. We help overcome CRM challenges, improve sales productivity, and enhance collaboration across departments, ensuring greater efficiency and smoother operations.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/development.webp')} alt='Salesforce experts texas' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Salesforce App Development</h3>
                                            <p className="wow fadeUp prose-lg">
                                                We bring your app ideas to life with practical, high-impact solutions. Based in Texas, our certified developers specialize in creating custom applications and deploying them seamlessly on leading platforms, ensuring functionality, scalability, and alignment with your business objectives.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/integration.webp')} alt='Salesforce partner texas' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Salesforce Integration</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Break down departmental silos and boost productivity with our seamless integration services. We connect core business systems such as ERP, CMS, DMS, and accounting software to ensure smooth data flow, better collaboration, and improved overall operational efficiency across your organization.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/migration.webp')} alt='Custom Salesforce solutions' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Salesforce Migration Services</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Effortlessly migrate from your legacy system with our trusted data migration services in Texas. Our experts ensure a smooth, secure transition while preserving the accuracy and integrity of your customer data throughout the entire migration process for minimal disruption.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/support.webp')} alt='Salesforce consulting texas' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Salesforce Support</h3>
                                            <p className="wow fadeUp prose-lg">
                                                We continuously monitor your system to detect and resolve issues before they escalate. With proactive oversight, we reduce downtime, maintain smooth operations, and help prevent major disruptions, keeping your business running efficiently and without unexpected interruptions.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='client-section'>
                            <div className='explore-heading text-left'>
                                <h2>Your Trusted Salesforce Consulting Partner in Texas – Certified Experts at Your Service</h2>
                                <p className="prose-lg">At Codezix, we are your go-to Salesforce consulting partner in Texas, offering certified expertise to help businesses maximize their Salesforce investment. Our team of skilled consultants works closely with you to customize solutions that streamline your operations and improve customer relationships. Whether you're implementing Salesforce for the first time or optimizing an existing setup, we ensure that every solution aligns with your business goals. As a trusted Salesforce consulting partner in Texas, we’re committed to delivering long-term success and continuous support. Let us help transform your CRM strategy today!</p>
                            </div>
                            <div className='row top'>
                                <Swiper
                                    breakpoints={{
                                        425: {
                                            slidesPerView: 2,
                                            spaceBetween: 10,
                                        },
                                        640: {
                                            slidesPerView: 3,
                                            spaceBetween: 10,
                                        },
                                        768: {
                                            slidesPerView: 4,
                                            spaceBetween: 30,
                                        },
                                        1024: {
                                            slidesPerView: 5,
                                            spaceBetween: 30,
                                        },
                                    }}
                                    autoplay={{
                                        delay: 2500,
                                        disableOnInteraction: false,
                                    }}
                                    pagination={{
                                        clickable: true,
                                    }}
                                    modules={[Pagination, Autoplay]}
                                    className="testimonialSwiper-client"
                                >
                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/4.webp" alt='Salesforce implementation texas' />
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/1.webp" alt='Codezix Salesforce services' />
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/2.webp" alt='Salesforce implementation texas' />
                                        </div>
                                    </SwiperSlide>

                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/3.webp" alt='Codezix Salesforce services' />
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/5.webp" alt='Salesforce implementation texas' />
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/6.webp" alt='Codezix Salesforce services' />
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/7.webp" alt='Salesforce implementation texas' />
                                        </div>
                                    </SwiperSlide>

                                </Swiper>
                            </div>
                        </div>

                        <div className="salesforce-product">
                            <div className='explore-heading text-left'>
                                <h2>Expertise in Salesforce Clouds – Powered by Salesforce Consultants in Texas</h2>
                                <p className="wow fadeUp prose-lg text-left">
                                    Our Salesforce consultants in Texas specialize in implementing and optimizing Salesforce Clouds to meet your business needs. With deep expertise across various Salesforce products, including Sales Cloud, Service Cloud, and Marketing Cloud, we tailor solutions to help you drive efficiency and enhance customer experiences. Whether you're new to Salesforce or looking to expand your current setup, our Salesforce consultants in Texas provide personalized guidance every step of the way. Let our experts help you harness the full power of Salesforce Clouds and take your business to new heights.
                                </p>
                            </div>
                            <div class="row mt-5">
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/sales-cloud">
                                            <h3 class="mt-0">Sales Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/service-cloud">
                                            <h3 class="mt-0">Service Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/marketing-cloud">
                                            <h3 class="mt-0">Marketing Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/community-cloud">
                                            <h3 class="mt-0">Community Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/finencial-service-cloud">
                                            <h3 class="mt-0">Financial Services Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/non-profit">
                                            <h3 class="mt-0">Nonprofit Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/cpq">
                                            <h3 class="mt-0">Salesforce CPQ</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/development-company-in-texas#">
                                            <h3 class="mt-0">Salesforce Chatter</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/community-cloud">
                                            <h3 class="mt-0">Community Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/einstein-analytics">
                                            <h3 class="mt-0">Einstein Analytics</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/development-company-in-texas#">
                                            <h3 class="mt-0">Salesforce Lightning</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/development-company-in-texas#">
                                            <h3 class="mt-0">Health Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="salesforce-product">
                            <div className='explore-heading text-center'>
                                <h2>Industries We Serve – Delivered by Expert Salesforce Developers in Texas</h2>
                                <p className="prose-lg">At Codezix, our team of Salesforce developers in Texas is dedicated to providing tailored Salesforce solutions for businesses in diverse industries. From healthcare and retail to finance and technology, we have the expertise to optimize your operations and improve customer experiences. Our Salesforce developers in Texas collaborate closely with your team to deliver solutions that are aligned with your specific business objectives. By leveraging the power of Salesforce, we help organizations automate workflows, enhance productivity, and achieve measurable results. Partner with us to transform your Salesforce platform and accelerate your business growth.</p>
                            </div>

                            <div class="row mob-imagebox">
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/healthcare.webp" alt="Salesforce implementation texas" />
                                        <div class="image-text">
                                            <p>Healthcare</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/retail.webp" alt="Codezix Salesforce services" />
                                        <div class="image-text">
                                            <p>E-Commerce</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/logistics.webp" alt="CRM solutions texas" />
                                        <div class="image-text">
                                            <p>Logistics</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/financial.webp" alt="Salesforce experts texas" />
                                        <div class="image-text">
                                            <p>Financial</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/manufacturing.webp" alt="Salesforce partner texas" />
                                        <div class="image-text">
                                            <p>Manufacturing</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/publicsector.webp" alt="Custom Salesforce solutions" />
                                        <div class="image-text">
                                            <p>Public Sector</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/media.webp" alt="Salesforce consulting texas" />
                                        <div class="image-text">
                                            <p>Media</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/it.webp" alt="Salesforce implementation texas" />
                                        <div class="image-text">
                                            <p>IT Industry</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/telecom.webp" alt="Codezix Salesforce services" />
                                        <div class="image-text">
                                            <p>Telecom</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/education.webp" alt="CRM solutions texas" />
                                        <div class="image-text">
                                            <p>Education</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="salesforce-product">
                            <div className='explore-heading text-left'>
                                <h2>Why work with Codezix ?</h2>
                            </div>

                            <div className="row bottom">
                                <div className="col-lg-6">
                                    <div className="why-listing mt-4">
                                        <ul>
                                            <li className="wow fadeUp prose-lg">Certified Salesforce Consulting Partner</li>
                                            <li className="wow fadeUp prose-lg">80+ skilled developers with over 300 certifications</li>
                                            <li className="wow fadeUp prose-lg">89% repeat business rate, showcasing client trust</li>
                                            <li className="wow fadeUp prose-lg">90% client retention rate, building lasting relationships</li>
                                            <li className="wow fadeUp prose-lg">More than 10 years of industry expertise</li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="why-listing mt-4">
                                        <ul>
                                            <li className="wow fadeUp prose-lg">Comprehensive End-to-End Support & Maintenance</li>
                                            <li className="wow fadeUp prose-lg">24/7 global Salesforce support, available across all time zones</li>
                                            <li className="wow fadeUp prose-lg">100% in-house development, guaranteeing top-tier quality control</li>
                                            <li className="wow fadeUp prose-lg">99% on-time project delivery, ensuring flawless execution</li>
                                            <li className="wow fadeUp prose-lg">Thorough testing for reliable, high-performance Salesforce solutions</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='cloud-demo' >
                            <div className='explore-heading text-left'>
                                <h2>Customer Success Stories</h2>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/casestudy/salesforce/images/pd1.webp" alt='CRM solutions texas' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">3 PL Central </h3>
                                            <p className="wow fadeUp prose-lg">
                                                Headquartered in California, <strong>3PL Central</strong> offers a cutting-edge warehouse management system (WMS) that optimizes operations, boosts customer satisfaction, and accelerates business growth.
                                            </p>
                                        </div>
                                        {/* <div className="services_button_right">
                                            <Link to="" ></Link>
                                        </div> */}
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/casestudy/salesforce/images/24-Fit-Club1.webp" alt='Salesforce experts texas' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">24 Fit Club </h3>
                                            <p className="wow fadeUp prose-lg">
                                                Based in the UK, <strong>24 Fit Club</strong> is a dynamic fitness community dedicated to promoting health and well-being. Their expert team provides premium fitness coaching, online classes, and innovative insights to inspire clients and promote body positivity.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/casestudy/salesforce/images/salesforce1.webp" alt='Salesforce partner texas' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Active Campaign </h3>
                                            <p className="wow fadeUp prose-lg">
                                                Salesforce is a powerful CRM platform offering a comprehensive enterprise solution, accessible on multiple devices. Its dynamic app marketplace enhances marketing and sales collaboration, driving lead generation and building high-quality pipelines.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/casestudy/salesforce/images/advologix.webp" alt='Custom Salesforce solutions' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Advologix</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Headquartered in Sugarland, Texas, Advologix is a digital consultancy specializing in legal document and case management. They assist law firms, legal departments, and public service organizations in streamlining case processing through centralized information management systems.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/casestudy/salesforce/images/concert_health.webp" alt='Salesforce experts texas' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Concert Health</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Concert Health helps physician practices integrate behavioral health services, including care management, brief therapy, and psychiatric consultations. With a team of expert clinicians, industry insights, and advanced technology, they improve patient care and outcomes.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/casestudy/salesforce/images/at-home-solutions.webp" alt='Salesforce partner texas' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">At Home Solutions</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Based in texas, At Home Solutions offers personalized healthcare services aimed at improving the quality of life for individuals of all ages. With over a decade of experience, they provide affordable, effective care, including companionship, tailored support, and essential medical services.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='cloud-demo' >
                            <div className='explore-heading text-left'>
                                <h2>Customer Success Stories</h2>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/blog/commerce.webp" alt='Custom Salesforce solutions' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Salesforce Commerce Cloud: Everything You Need to Know </h3>
                                            <p className="wow fadeUp prose-lg">
                                                In today’s digital age, e-commerce is essential for business success, driving fierce competition. As online shopping demand grows, businesses must adopt scalable, innovative solutions to stay competitive and meet evolving consumer expectations.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/blog/agent.webp" alt='Salesforce consulting texas' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Ultimate Guide to Salesforce Agentforce</h3>
                                            <p className="wow fadeUp prose-lg">
                                                A major highlight of 2024 is Salesforce Agentforce. On Day Three of Dreamforce 2024, Salesforce introduced Agentforce, an innovative AI-powered tool aimed at boosting employee productivity.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/blog/marketing.webp" alt='Salesforce implementation texas' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">
                                                Understanding Salesforce MuleSoft & How Codezix Supports Implementation & Customization
                                            </h3>
                                            <p className="wow fadeUp prose-lg">
                                                In today’s digital landscape, businesses rely on a wide range of applications and platforms to optimize operations and enhance customer experiences. However, achieving seamless integration can be challenging—this is where Salesforce MuleSoft plays a critical role...
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}

export default Texas;